'use strict';
/**
 * Message sent by a newcommer to its contact when it joins the network.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MJoin =
/**
   * @param {string} inview The identifier of the inview of the newcomer.
   * @param {object} descriptor The descriptor of the newcomer.
   */
function MJoin(inview, descriptor) {
  _classCallCheck(this, MJoin);

  this.peer = inview;
  this.descriptor = descriptor;
  this.type = 'MJoin';
};

module.exports = MJoin;